module.exports = __webpack_public_path__ + "assets/img/live24.3673c69b.png";